import { useTranslation } from 'react-i18next'
import {
    OreButton,
    OreStack,
    OreStepper,
    OreText,
    SvgArrowWidget
} from '@edenredespana/oreneta'
import { useUserData } from '@/User/ui/context'
import { HelpCenterTranslations } from '@/HelpCenter/ui/helpCenterTranslations'

interface NewTicketHeaderProps {
    step: number
    setIsModalOpen: (isOpen: boolean) => void
}
export const NewTicketHeader = ({ step, setIsModalOpen }: NewTicketHeaderProps): JSX.Element => {
    const { t } = useTranslation()
    const { user, merchant } = useUserData()

    const generateFullName = (): string => {
        if (!user) return ''
        return `${user?.user?.name} ${user?.user?.surname} ${user?.user?.surname2 ? user?.user?.surname2 : ''}`
    }

    const handleBackClick = () => {
        if (step > 1) {
            setIsModalOpen(true)
        }
    }

    return (
        <OreStack space="medium" placeContent="stretch">
            <OreStack space="large" direction="row" placeContent="space-between">
                <OreButton
                    category={'tertiary'}
                    icon={<SvgArrowWidget direction="left" />}
                    onClick={handleBackClick}
                >
                    {t(HelpCenterTranslations.navigation.back)}
                </OreButton>
                <OreText size="text-lg">{t(HelpCenterTranslations.newTicket)}</OreText>
            </OreStack>
            <OreStack space="2xsmall" >
                <OreText size="text-md" bold>{generateFullName()}</OreText>
                <OreText size="text-md">{merchant?.name}</OreText>
            </OreStack>
            <OreStepper
                activeStep={step}
                steps={[
                    "\u200B",
                    "\u200B\u200B",
                    "\u200B\u200B\u200B",
                    "\u200B\u200B\u200B\u200B"
                ]}
            />
        </OreStack>
    )
}